module.exports = __webpack_public_path__ + "img/about-9.84a12224.jpg";